import React, { useEffect, useState } from 'react';

import AccountGroupDropdown from './AccountGroupDropdown';
import useSelectedGroupId from '../../hooks/useSelectedGroupId';
import useAccountCustomer from '../../hooks/useAccountCustomer';
import { Group } from '../../__generated__/pge-types';

type Props = {
  onSelect?: (groupId: string) => void;
  isDisplay?: number | boolean;
};

export default function AccountGroupDropdownContainer({
  onSelect,
  isDisplay = false,
}: Props) {
  const { selectedGroupId, setSelectedGroupId } = useSelectedGroupId();

  const [groupsState, setGroupsState] = useState<Group[]>([]);
  const [defaultGroupState, setDefaultGroupState] = useState<
    Group | undefined
  >();

  const { groups, defaultGroup, loading } = useAccountCustomer();

  useEffect(() => {
    setGroupsState(groups);
    setDefaultGroupState(defaultGroup);
  }, [loading]);

  if (groupsState.length === 0) {
    return null;
  }

  return (
    <AccountGroupDropdown
      isDisplay={isDisplay}
      groups={groupsState}
      selectedGroupId={selectedGroupId || defaultGroupState?.groupId!}
      onSelect={grpId => {
        setSelectedGroupId(grpId);
        if (onSelect !== undefined) {
          onSelect(grpId);
        }
      }}
    />
  );
}
